var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPausedCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 78,
    viewBox: "0 0 68 78",
    fill: "none",
    color: "red",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.41711V6.81888L15.4447 0H10.0047L0 4.41711Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7271 0L0 10.9171V13.3189L30.1671 0H24.7271Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4496 0L0 17.4171V19.8189L44.8896 0H39.4496Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.172 0L0 23.9171V26.3189L59.612 0H54.172Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 0.394894L0 30.4171V32.8189L68 2.79667V0.394894Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68 6.89489L0 36.9171V39.3189L68 9.29667V6.89489Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 13.3949L0 43.4171V45.8189L68 15.7967V13.3949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68 19.8949L0 49.9171V52.3189L68 22.2967V19.8949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68 26.3949L0 56.4171V58.8189L68 28.7967V26.3949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32.8949L0 62.9171V65.3189L68 35.2967V32.8949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39.3949L0 69.4171V71.8189L68 41.7967V39.3949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45.8949L0 75.9171V78H0.722263L68 48.2967V45.8949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52.3949L10.0047 78H15.4447L68 54.7967V52.3949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68 58.8949L24.7271 78H30.1671L68 61.2967V58.8949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65.3949L39.4496 78H44.8896L68 67.7967V65.3949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68 71.8949L54.172 78H59.612L68 74.2967V71.8949Z",
    fill: "#9DB2CE",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedCalendar);
export default __webpack_public_path__ + "static/media/paused-calendar.6f62ab514e2bffe674ea54d45ae6276e.svg";
export { ForwardRef as ReactComponent };